import { AdvertisementModal } from "nvent-web/components/AdvertismentModal/AdvertisementModal";
import React, { Component } from "react";
import { compose } from "recompose";

import { inject } from "mobx-react";
import ruAdvertisementImage from "nvent-web/assets/CertifiedProOffers/offer-ru-1.jpg";
import { KnownLocale } from "nvent-web/i18n";
import AppStore from "nvent-web/stores/App";
import { FormattedMessage, InjectedIntlProps, injectIntl } from "react-intl";

const RU_ADVERTISEMENT_TO_MUTE_KEY = "muteOffer.ru.202012";

const advertisementModalImagesForLocales: { [K in KnownLocale]?: string } = {
  ru: ruAdvertisementImage,
};

interface AdvertisementsInnerProps extends InjectedIntlProps {
  app: AppStore;
}

class AdvertisementsInner extends Component<AdvertisementsInnerProps> {
  state = {
    showAdvertisementModal: true,
  };

  render() {
    const { app } = this.props;
    const advertisementDisabledInLocalStorage = localStorage.getItem(RU_ADVERTISEMENT_TO_MUTE_KEY) !== null;

    return (
      <>
        {!advertisementDisabledInLocalStorage && advertisementModalImagesForLocales[app.locale] && (
          <AdvertisementModal
            title={<FormattedMessage id="advertismentModal.title" />}
            advertisementName={RU_ADVERTISEMENT_TO_MUTE_KEY}
            isOpen={this.state.showAdvertisementModal}
            handleClose={this.closeAdvertisementModal}
            imageSrc={advertisementModalImagesForLocales[app.locale]!}
            center
          />
        )}
      </>
    );
  }

  closeAdvertisementModal = (advertisementName: string, showAgain: boolean) => {
    this.setState({ showAdvertisementModal: false });
    if (showAgain) {
      localStorage.setItem(advertisementName, "");
    }
  };
}

export const Advertisements = compose<AdvertisementsInnerProps, {}>(
  injectIntl,
  inject("app")
)(AdvertisementsInner);
